export default __webpack_public_path__ + "static/media/new_avatar.46197609.svg";